import type { Action, Reducer } from "@reduxjs/toolkit";
import { VsCodeState, VsCodeActionTypes } from "./types";

const initialState: VsCodeState = {
    connectionStatus: "CLOSED"
};

export const vsCodeReducer: Reducer<VsCodeState, Action, VsCodeState> = (
    state = initialState,
    action: VsCodeActionTypes
): VsCodeState => {
    switch (action.type) {
        case "SET_CONNECTION_STATUS":
            return {
                connectionStatus: action.status
            };

        default:
            return state;
    }
}